import { render, staticRenderFns } from "./WhySellWithUs.vue?vue&type=template&id=27badb6c&scoped=true&"
import script from "./WhySellWithUs.vue?vue&type=script&lang=ts&"
export * from "./WhySellWithUs.vue?vue&type=script&lang=ts&"
import style0 from "./WhySellWithUs.vue?vue&type=style&index=0&id=27badb6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27badb6c",
  null
  
)

export default component.exports